import React from 'react';
import { useDispatch } from 'react-redux';
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type';
import useLanguage from '../../../contexts/language/LanguageContext';
import { getTranslationByPath } from '../../../utils/translations';
import { Footer } from '../../../layout/footer/Footer';
import { MainContent } from '../../../layout/content/MainContent';
import { setSelectedPage } from '../../../store/slices/app/appSlice';


type Block = {
  image: string
  translation: TranslationPath
}

export type TextListTemplateType = {
  transitionUrl: TransitionUrl
  blocks: Block[]
  suffixText?: string
  errorText?: string
  continueBtnText?: string
  onContinue?: () => void
  disabledContinueBtn?: boolean
  hideContinueBtn?: boolean
  showLoaderInContinueBtn?: boolean
  textVariables?: Map<string, string>
}

type Props = {
  page: Page<TextListTemplateType>
  children?: React.ReactElement
}

export const TextListTemplate = (props: Props): React.ReactElement => {
  const language = useLanguage()
  const dispatch = useDispatch()

  return <div><MainContent>
    <div>
      {
        props.page.data.blocks.map(row => {
          let text = getTranslationByPath(language.translations, row.translation)
          if (props.page.data.textVariables) {
            for (const textVariable of props.page.data.textVariables.entries()) {
              text = text.replace(textVariable[0], textVariable[1])
            }
          }
          return (
            <div key={row.image} className="flex items-center mb-10">
              <img src={`${process.env.APP_DATA_LINK + row.image}`} className="w-16 h-16 mr-10" alt="" />
              <span dangerouslySetInnerHTML={{ __html: text }} />
            </div>
          )
        })
      }

      {props.page.data.suffixText && (
        <div>{getTranslationByPath(language.translations, props.page.data.suffixText)}</div>
      )}

      {props.page.data.errorText && (
        <div style={{ color: 'red', fontWeight: 'bold' }}>{getTranslationByPath(language.translations, props.page.data.errorText)}</div>
      )}

      {props.children}
    </div>
  </MainContent>

  <Footer
    backUrl={props.page.footer?.back}
    disabledContinueBtn={props.page.data.disabledContinueBtn}
    showLoaderInContinueBtn={props.page.data.showLoaderInContinueBtn}
    onContinue={props.page.data.onContinue ? props.page.data.onContinue : (props.page.data.hideContinueBtn ? undefined : () => {
      dispatch(setSelectedPage(props.page.data.transitionUrl))
    })}
    continueText={props.page.data.continueBtnText ? getTranslationByPath(language.translations, props.page.data.continueBtnText) : undefined}
  />

  </div>
}
